// Lightweight bridge to decouple analytics from store / toast slice.
// Register a toast dispatcher at app bootstrap; analytics code calls notifyToast without importing the store.

export type ToastLevel = 'success' | 'error' | 'default'

let _toastDispatcher: ((msg: string, level: ToastLevel) => void) | null = null

export function registerToastDispatcher(toastDispatcher: typeof _toastDispatcher) {
    _toastDispatcher = toastDispatcher
}

export function notifyToast(message: string, level: ToastLevel = 'success') {
    _toastDispatcher?.(message, level)
}
